import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/translations";
import { resolveImg } from "@/lib/api";
import { Reveal } from "./Reveal";

export const Videos = ({ content }) => {
  const { lang } = useLang();
  const videos = content.videos || [];
  if (videos.length === 0) return null;

  return (
    <section id="videos" className="relative z-10 bg-[#0A0A0A] py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <span className="text-xs tracking-[0.25em] uppercase font-bold text-[#FF5A00]">{t("videos_kicker", lang)}</span>
          <h2 className="font-display uppercase text-5xl md:text-7xl mt-3 leading-none">{t("videos_title", lang)}</h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {videos.map((v, i) => (
            <motion.div
              key={i}
              data-testid={`video-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#121212] aspect-[4/5]"
            >
              <video
                src={resolveImg(v.url)}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                controls
                className="w-full h-full object-cover"
              />
              <div className="pointer-events-none absolute top-4 left-4 rounded-full bg-black/60 backdrop-blur px-4 py-1.5">
                <span className="font-accent text-xl text-[#A8E010]">{lang === "es" ? v.title_es : v.title_en}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
